<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content class="mat-typography">
  {{ data.message }}
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-button (click)="close(true)" cdkFocusInitial>Confirm</button>
  <button mat-button (click)="close(false)" color="warn">Cancel</button>
</div>
